import {
  base,
  validations
} from "@/components/Tools/FormHelperFactory/Configurations/baseConfigurations";

export const textEditor = {
  ...base,
  ...validations
};
